import { useCallback } from "react";
import {
  type GoogleLoginMutation,
  type GoogleLoginMutationVariables,
} from "@generated/graphql";
import { useMutation } from "@edreamsodigeo/frontend-api-client";

import { GOOGLE_LOGIN_MUTATION } from "../operations/mutations";
import type { GoogleLoginMutationType, UseMutationType } from "./contract";

export const useGoogleIdentity = (): UseMutationType => {
  const { mutate, loading } = useMutation<
    GoogleLoginMutation,
    GoogleLoginMutationVariables
  >(GOOGLE_LOGIN_MUTATION);

  const googleLoginMutate: GoogleLoginMutationType = useCallback(
    (request, { onSuccess, onError }) => {
      mutate(request, {
        onSuccess,
        onError,
      });
    },
    [mutate],
  );

  return {
    mutate: googleLoginMutate,
    loading,
  };
};
